module.exports = __webpack_public_path__ + "static/media/imagebox_1.f6362326.jpg";